export default "__VITE_ASSET__CEQBYoUK__"